export default "__VITE_ASSET__Dxs5YVdy__"